export default [
  {
    name: 'pets',
    labelKey: 'search.filter.pets',
    tracking: 'ga-search-form-pets'
  },
  {
    name: 'smokingAllowed',
    labelKey: 'search.filter.smoking_allowed',
    tracking: 'ga-search-form-smokingAllowed'
  },
  {
    name: 'students',
    labelKey: 'search.filter.students',
    tracking: 'ga-search-form-students'
  },
  {
    name: 'couples',
    labelKey: 'search.filter.couples',
    tracking: 'ga-search-form-couples'
  },
  {
    name: 'only_female',
    labelKey: 'search.filter.only_females',
    tracking: 'ga-search-form-only-females'
  },
  {
    name: 'only_male',
    labelKey: 'search.filter.only_males',
    tracking: 'ga-search-form-only-males'
  }
];
